import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'currencyFormat' })
export class CurrencyFormatPipe implements PipeTransform {
  transform(value: number | string | null | undefined, currency: any, minFraction = 2): string { 

    if (value === null || value === undefined || value === '') return '';
    const num = typeof value === 'string' ? parseFloat(value) : value;
    if (isNaN(num)) return String(value);
    const locale = currency?.toLowerCase() === 'usd' ? 'en-US' : 'en-ZW';
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency,
      minimumFractionDigits: minFraction
    }).format(num);
  }
}

//usage : {{ capitol.amount | currencyFormat }}
